import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import Text from '../components/shared/Text';
import Icon from '../components/shared/Icon';
import Image from '../components/shared/Image';
import Card from '../components/shared/Card';
import { moveToBuilding } from '../components/BuildingScreen';

import { getBuilding } from '../utils/buildingUtils';
import { getLocalValue, t } from '../utils/appUtils';

import appStore from '../stores/app';

import { buildingsImageRequire } from '../lib/imagesRequire';
import { BG_OFFSET, PaperBackground, MAP_DIMENSIONS } from '../components/Island/IslandScreen';
import { WINDOW_WIDTH } from '../components/styleConstants';

// const MAX_IMAGE_HEIGHT = 500;
// const IMAGE_PROPORTION = 900 / MAX_IMAGE_HEIGHT;
// let IMAGE_WIDTH = WINDOW_WIDTH - PADDING * 2;

type Props = {
  id: string;
};

const Castle = ({ id }: Props) => {
  const building = getBuilding(appStore.initData.buildings, id);
  if (!building) return null;

  return (
    <View>
      <PaperBackground width={MAP_DIMENSIONS.width} height={MAP_DIMENSIONS.height} />
      <View
        style={{
          marginLeft:
            MAP_DIMENSIONS.width + 15 > WINDOW_WIDTH
              ? BG_OFFSET / 2
              : (WINDOW_WIDTH - MAP_DIMENSIONS.width + 15) / 2,
          marginTop: BG_OFFSET / 2,
          width: MAP_DIMENSIONS.width - BG_OFFSET,
          height: MAP_DIMENSIONS.height - BG_OFFSET,
          overflow: 'hidden',
        }}
      >
        <Image
          style={{
            width: MAP_DIMENSIONS.width - BG_OFFSET,
            height: MAP_DIMENSIONS.height - BG_OFFSET,
          }}
          resizeMode="stretch"
          source={buildingsImageRequire(building.data.image)}
        />
      </View>
      <Card
        title={getLocalValue(building)}
        menuItemsLength={building.children!.length}
        style={{
          position: 'absolute',
          right: 0,
        }}
      >
        {building.children!.map((item: any, index: number) => (
          <View key={item.id} style={{ flexDirection: 'row' }}>
            <TouchableOpacity
              style={{ flexDirection: 'row', marginTop: index ? 4 : 0 }}
              onPress={() => {
                moveToBuilding(item.id);
              }}
            >
              <Text bold>{getLocalValue(item)}</Text>
              <Icon
                style={{ marginTop: 1, marginLeft: 4, width: 16, height: 16 }}
                size={14}
                name="enter"
                title={t('enter')}
                source={require('../assets/images/enter.png')}
              />
            </TouchableOpacity>
          </View>
        ))}
      </Card>
    </View>
  );
};

export default Castle;
